<template>
  <div>
    <el-form label-position="left" label-width="150px">

      <el-divider content-position="left">备用金信息</el-divider>
      <el-form-item label="申请人" prop="applyUser">
        <el-input v-model="detail.applyUser" readonly></el-input>
      </el-form-item>

      <el-form-item label="申请类型" prop="applyUser">
        <el-radio-group v-model="detail.type" style="cursor: not-allowed;pointer-events:none">
          <el-radio :label="1">项目费用</el-radio>
          <el-radio :label="2">管理费用</el-radio>
        </el-radio-group>
      </el-form-item>

      <div v-if="detail.type === 1">
        <el-form-item label="申请项目" prop="projectName">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>
      </div>

      <el-form-item label="申请金额" prop="amount">
        <el-input v-model="detail.amount" readonly>
          <template slot="append">{{ paymentUpperMap.applyMoney }}</template>
        </el-input>
      </el-form-item>

      <el-form-item label="申请用途" prop="remark">
        <el-input type="textarea" rows=5 v-model="detail.remark" readonly></el-input>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import {requestApplyDetail} from "@/api";
import {digitUppercase} from "@/util";
export default {
  name: "ProjectDialog",
  components: {},
  props: {
     "applyId": "",
     "applyServiceId": "",
     "applyType": "",
     "role": 0
  },
  data() {
    return {
      audits: [],
      auditHistory: [],
      nodes: [],
      detail: {},
      user: {},
    }
  },
  computed: {
    paymentUpperMap() {
      return {
        applyMoney: digitUppercase(this.detail.amount)
      }
    }
  },
  created() {
    this.getObject()
  },
  methods: {
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType,
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.user = res.object.user
            this.nodes = res.object.nodes
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>
